// deps
import { defineMessage } from "react-intl";

// Classements citybreak

/** Confort */
export const ROOM_RANKING_VALUE_CONFORT = "con";
/** Premium */
export const ROOM_RANKING_VALUE_PREMIUM = "pre";
/** Luxury */
export const ROOM_RANKING_VALUE_LUXURY = "lux";

export const ROOM_RANKINGS = {
  [ROOM_RANKING_VALUE_CONFORT]: {
    id: ROOM_RANKING_VALUE_CONFORT,
    label: "Confort",
  },
  [ROOM_RANKING_VALUE_PREMIUM]: {
    id: ROOM_RANKING_VALUE_PREMIUM,
    label: "Premium",
  },
  [ROOM_RANKING_VALUE_LUXURY]: {
    id: ROOM_RANKING_VALUE_LUXURY,
    label: "Luxury",
  },
};

export const ROOM_RANKING_INTL_MESSAGES = {
  byValue: {
    [ROOM_RANKING_VALUE_CONFORT]: {
      label: defineMessage({
        defaultMessage: "confort",
      }),
    },
    [ROOM_RANKING_VALUE_PREMIUM]: {
      label: defineMessage({
        defaultMessage: "premium",
      }),
    },
    [ROOM_RANKING_VALUE_LUXURY]: {
      label: defineMessage({
        defaultMessage: "luxury",
      }),
    },
  },
  byCount: {
    1: {
      label: defineMessage({
        defaultMessage: "1 épi",
      }),
    },
    2: {
      label: defineMessage({
        defaultMessage: "2 épis",
      }),
    },
    3: {
      label: defineMessage({
        defaultMessage: "3 épis / confort",
      }),
    },
    4: {
      label: defineMessage({
        defaultMessage: "4 épis / premium",
      }),
    },
    5: {
      label: defineMessage({
        defaultMessage: "5 épis / luxury",
      }),
    },
  },
};

export const ROOM_RANKING_LIST = Object.values(ROOM_RANKINGS);

// Étages

/** Sous-sol n°2 */
export const ROOM_FLOOR_VALUE_BASEMENT_2 = "-2";
/** Sous-sol n°1 */
export const ROOM_FLOOR_VALUE_BASEMENT_1 = "-1";
/** Rez-de-chaussée */
export const ROOM_FLOOR_VALUE_0 = "0";
/** Entresol */
export const ROOM_FLOOR_VALUE_MEZZANINE = "99";
/** Rez-de-jardin */
export const ROOM_FLOOR_VALUE_GARDEN = "98";
/** 1er étage */
export const ROOM_FLOOR_VALUE_FLOOR_1 = "1";
/** 2ème étage */
export const ROOM_FLOOR_VALUE_FLOOR_2 = "2";
/** 3ème étage */
export const ROOM_FLOOR_VALUE_FLOOR_3 = "3";
/** 4ème étage */
export const ROOM_FLOOR_VALUE_FLOOR_4 = "4";
/** 5ème étage */
export const ROOM_FLOOR_VALUE_FLOOR_5 = "5";
/** 6ème étage */
export const ROOM_FLOOR_VALUE_FLOOR_6 = "6";
/** 7ème étage */
export const ROOM_FLOOR_VALUE_FLOOR_7 = "7";
/** 8ème étage */
export const ROOM_FLOOR_VALUE_FLOOR_8 = "8";
/** 9ème étage */
export const ROOM_FLOOR_VALUE_FLOOR_9 = "9";
/** 10ème étage */
export const ROOM_FLOOR_VALUE_FLOOR_10 = "10";

export const ROOM_FLOORS = {
  [ROOM_FLOOR_VALUE_BASEMENT_2]: {
    id: ROOM_FLOOR_VALUE_BASEMENT_2,
    label: "sous-sol n°2",
  },
  [ROOM_FLOOR_VALUE_BASEMENT_1]: {
    id: ROOM_FLOOR_VALUE_BASEMENT_1,
    label: "sous-sol n°1",
  },
  [ROOM_FLOOR_VALUE_0]: {
    id: ROOM_FLOOR_VALUE_0,
    label: "rez-de-chaussée",
  },
  [ROOM_FLOOR_VALUE_MEZZANINE]: {
    id: ROOM_FLOOR_VALUE_MEZZANINE,
    label: "entresol",
  },
  [ROOM_FLOOR_VALUE_GARDEN]: {
    id: ROOM_FLOOR_VALUE_GARDEN,
    label: "rez-de-jardin",
  },
  [ROOM_FLOOR_VALUE_FLOOR_1]: {
    id: ROOM_FLOOR_VALUE_FLOOR_1,
    label: "1er étage",
  },
  [ROOM_FLOOR_VALUE_FLOOR_2]: {
    id: ROOM_FLOOR_VALUE_FLOOR_2,
    label: "2ème étage",
  },
  [ROOM_FLOOR_VALUE_FLOOR_3]: {
    id: ROOM_FLOOR_VALUE_FLOOR_3,
    label: "3ème étage",
  },
  [ROOM_FLOOR_VALUE_FLOOR_4]: {
    id: ROOM_FLOOR_VALUE_FLOOR_4,
    label: "4ème étage",
  },
  [ROOM_FLOOR_VALUE_FLOOR_5]: {
    id: ROOM_FLOOR_VALUE_FLOOR_5,
    label: "5ème étage",
  },
  [ROOM_FLOOR_VALUE_FLOOR_6]: {
    id: ROOM_FLOOR_VALUE_FLOOR_6,
    label: "6ème étage",
  },
  [ROOM_FLOOR_VALUE_FLOOR_7]: {
    id: ROOM_FLOOR_VALUE_FLOOR_7,
    label: "7ème étage",
  },
  [ROOM_FLOOR_VALUE_FLOOR_8]: {
    id: ROOM_FLOOR_VALUE_FLOOR_8,
    label: "8ème étage",
  },
  [ROOM_FLOOR_VALUE_FLOOR_9]: {
    id: ROOM_FLOOR_VALUE_FLOOR_9,
    label: "9ème étage",
  },
  [ROOM_FLOOR_VALUE_FLOOR_10]: {
    id: ROOM_FLOOR_VALUE_FLOOR_10,
    label: "10ème étage",
  },
};

export const ROOM_FLOOR_LIST = Object.values(ROOM_FLOORS);

// Méthode de paiement pour la location directe

export const ROOM_PAYMENT_VALUE_CB = "cb";
export const ROOM_PAYMENT_VALUE_CHQ = "chq";
export const ROOM_PAYMENT_VALUE_VIR = "vir";
export const ROOM_PAYMENT_VALUE_ESP = "esp";
export const ROOM_PAYMENT_VALUE_ANCV = "ancv";
export const ROOM_PAYMENT_VALUE_PAYPAL = "paypal";

export const ROOM_PAYMENTS = {
  [ROOM_PAYMENT_VALUE_CB]: {
    id: ROOM_PAYMENT_VALUE_CB,
    label: "carte bancaire",
    selectable: true,
  },
  [ROOM_PAYMENT_VALUE_CHQ]: {
    id: ROOM_PAYMENT_VALUE_CHQ,
    label: "chèque",
    selectable: true,
  },
  [ROOM_PAYMENT_VALUE_VIR]: {
    id: ROOM_PAYMENT_VALUE_VIR,
    label: "virement",
    selectable: true,
  },
  [ROOM_PAYMENT_VALUE_ESP]: {
    id: ROOM_PAYMENT_VALUE_ESP,
    label: "espèce",
    selectable: true,
  },
  [ROOM_PAYMENT_VALUE_ANCV]: {
    id: ROOM_PAYMENT_VALUE_ANCV,
    label: "chèques vacances",
    selectable: true,
  },
  [ROOM_PAYMENT_VALUE_PAYPAL]: {
    id: ROOM_PAYMENT_VALUE_PAYPAL,
    label: "Paypal",
    selectable: true,
  },
};

export const ROOM_PAYMENT_LIST = Object.values(ROOM_PAYMENTS);

// Type de pièce (attribut virtuel)

/** Studio */
export const ROOM_VIRTUAL_PIECE_TYPE_VALUE_STUDIO = "studio";
/** Salon */
export const ROOM_VIRTUAL_PIECE_TYPE_VALUE_LOUNGE = "lounge";
/** Salle à manger */
export const ROOM_VIRTUAL_PIECE_TYPE_VALUE_DINING_ROOM = "dining_room";
/** Cuisine */
export const ROOM_VIRTUAL_PIECE_TYPE_VALUE_KITCHEN = "kitchen";
/** Séjour */
export const ROOM_VIRTUAL_PIECE_TYPE_VALUE_LIVING_ROOM = "living_room";
/** Chambre */
export const ROOM_VIRTUAL_PIECE_TYPE_VALUE_BEDROOM = "bedroom";
/** Salle de bain */
export const ROOM_VIRTUAL_PIECE_TYPE_VALUE_BATHROOM = "bathroom";
/** Salle d’eau */
export const ROOM_VIRTUAL_PIECE_TYPE_VALUE_SHOWER_ROOM = "shower_room";
/** WC */
export const ROOM_VIRTUAL_PIECE_TYPE_VALUE_TOILET = "toilet";
/** Salle de bain et WC */
export const ROOM_VIRTUAL_PIECE_TYPE_VALUE_SHOWER_ROOM_AND_TOILET =
  "shower_room_and_toilet";
/** Salle d’eau et WC */
export const ROOM_VIRTUAL_PIECE_TYPE_VALUE_BATHROOM_AND_TOILET =
  "bathroom_and_toilet";
/** Mezzanine */
export const ROOM_VIRTUAL_PIECE_TYPE_VALUE_MEZZANINE = "mezzanine";
/** Autre */
export const ROOM_VIRTUAL_PIECE_TYPE_VALUE_OTHER = "other";
/** Dégagements */
export const ROOM_VIRTUAL_PIECE_TYPE_VALUE_CLEARANCE = "clearance";

export const ROOM_VIRTUAL_PIECE_TYPES = {
  [ROOM_VIRTUAL_PIECE_TYPE_VALUE_STUDIO]: {
    id: ROOM_VIRTUAL_PIECE_TYPE_VALUE_STUDIO,
    label: "studio",
  },
  [ROOM_VIRTUAL_PIECE_TYPE_VALUE_LOUNGE]: {
    id: ROOM_VIRTUAL_PIECE_TYPE_VALUE_LOUNGE,
    label: "salon",
  },
  [ROOM_VIRTUAL_PIECE_TYPE_VALUE_DINING_ROOM]: {
    id: ROOM_VIRTUAL_PIECE_TYPE_VALUE_DINING_ROOM,
    label: "salle à manger",
  },
  [ROOM_VIRTUAL_PIECE_TYPE_VALUE_KITCHEN]: {
    id: ROOM_VIRTUAL_PIECE_TYPE_VALUE_KITCHEN,
    label: "cuisine",
  },
  [ROOM_VIRTUAL_PIECE_TYPE_VALUE_LIVING_ROOM]: {
    id: ROOM_VIRTUAL_PIECE_TYPE_VALUE_LIVING_ROOM,
    label: "séjour",
  },
  [ROOM_VIRTUAL_PIECE_TYPE_VALUE_BEDROOM]: {
    id: ROOM_VIRTUAL_PIECE_TYPE_VALUE_BEDROOM,
    label: "chambre",
  },
  [ROOM_VIRTUAL_PIECE_TYPE_VALUE_BATHROOM]: {
    id: ROOM_VIRTUAL_PIECE_TYPE_VALUE_BATHROOM,
    label: "salle de bain",
  },
  [ROOM_VIRTUAL_PIECE_TYPE_VALUE_SHOWER_ROOM]: {
    id: ROOM_VIRTUAL_PIECE_TYPE_VALUE_SHOWER_ROOM,
    label: "salle d’eau",
  },
  [ROOM_VIRTUAL_PIECE_TYPE_VALUE_TOILET]: {
    id: ROOM_VIRTUAL_PIECE_TYPE_VALUE_TOILET,
    label: "WC",
  },
  [ROOM_VIRTUAL_PIECE_TYPE_VALUE_SHOWER_ROOM_AND_TOILET]: {
    id: ROOM_VIRTUAL_PIECE_TYPE_VALUE_SHOWER_ROOM_AND_TOILET,
    label: "salle d’eau et WC",
  },
  [ROOM_VIRTUAL_PIECE_TYPE_VALUE_BATHROOM_AND_TOILET]: {
    id: ROOM_VIRTUAL_PIECE_TYPE_VALUE_BATHROOM_AND_TOILET,
    label: "salle de bain et WC",
  },
  [ROOM_VIRTUAL_PIECE_TYPE_VALUE_MEZZANINE]: {
    id: ROOM_VIRTUAL_PIECE_TYPE_VALUE_MEZZANINE,
    label: "mezzanine",
  },
  [ROOM_VIRTUAL_PIECE_TYPE_VALUE_OTHER]: {
    id: ROOM_VIRTUAL_PIECE_TYPE_VALUE_OTHER,
    label: "autre",
  },
  [ROOM_VIRTUAL_PIECE_TYPE_VALUE_CLEARANCE]: {
    id: ROOM_VIRTUAL_PIECE_TYPE_VALUE_CLEARANCE,
    label: "dégagements",
  },
};

export const ROOM_VIRTUAL_PIECE_TYPE_LIST = Object.values(
  ROOM_VIRTUAL_PIECE_TYPES,
);

// Permissions personnalisées pour les mandaires

/** Voir le détail d’un hébergement */
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_SHOW = "rooms.show";
/** Voir les réservations d’un hébergement */
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_BOOKING =
  "rooms.booking";
/** Voir les statistiques d’un hébergement */
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_METRICS =
  "rooms.metrics";
/** Voir la fiche hébergement en PDF */
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_BOOKLET =
  "rooms.booklet";
/** Modifier les promotions d’un hébergement */
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_DISCOUNTS =
  "rooms.discounts";
/** Modifier les disponibilités (vue annuelle) d’un hébergement */
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_ANNUAL_PERIOD =
  "rooms.annualPeriod";
/** Modifier les disponibilités d’un hébergement */
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_PERIOD = "rooms.period";
/** Modifier les saisons d’un hébergement */
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_SEASONS =
  "rooms.seasons";
/** Modifier les tarifs d’un hébergement */
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_SEASONS_SETTINGS =
  "rooms.seasonsSettings";
/** Modifier les photos d’un hébergement */
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_PHOTO = "rooms.photo";
/** Modifier les informations d’un hébergement */
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_EDIT = "rooms.edit";
/** Créer une réservation pour un hébergement */
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_BOOK = "rooms.book";
/** Modifier les fonctionnalités d’un hébergement */
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_FEATURES =
  "rooms.features";
/** Intégrer un hébergement sur un site externe */
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_INTEGRATE =
  "rooms.integrate";
/** Voir les avis clients d’un hébergement */
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_COMMENTS =
  "rooms.comment";
/** Lister les réservations */
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_INDEX =
  "bookings.index";
/** Télécharger le résumé d’une réservation */
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_RESUME =
  "bookings.resume";
/** Confirmer la location sur demande d’une réservation */
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_CONFIRM_OACK =
  "bookings.confirmOack";
/** Confirmer une réservation de dernière minute */
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_CONFIRM_VDM =
  "bookings.confirmVdm";
/** Télécharger le bon d’échange d’une réservation */
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_VOUCHER =
  "bookings.voucher";
/** Télécharger l’attestation de séjour d’une réservation */
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_CERTIFICATE =
  "bookings.certificate";
/** Télécharger le contrat de location d’une réservation */
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_CONTRACT =
  "bookings.contract";
/** Modifier les voyageurs d’une réservation pour l’attestation de séjour */
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_TRAVELERS =
  "bookings.travelers";
/** Voir le détail d’une réservation */
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_SHOW =
  "bookings.show";
/** Voir l’historique des paiements d’une réservation en location directe */
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_PAYMENT_HISTORY =
  "bookings.paymentHistory";
/** Ajouter des paiements sur un réservation en location directe */
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_PAY = "bookings.pay";
/** Modifier une réservation en location directe */
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_EDIT =
  "bookings.edit";
/** Valider une réservation en location directe en devis */
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_PROMISE =
  "bookings.promise";
/** Refuser une réservation en location directe en devis */
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_ABORT =
  "bookings.abort";
/** Restaurer une réservation en location directe */
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_RESTORE =
  "bookings.restore";
/** Annuler une réservation en location directe */
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_CANCEL =
  "bookings.cancel";
/** Gère l’accueil des voyageurs */
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_WELCOME_TRAVELERS =
  "bookings.welcomeTravelers";
// Recevoir les newsletters
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_NEWSLETTER_INDEX =
  "newsletters.index";
/** Recevoir les documents propriétaire */
export const ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_DOCUMENTS_INDEX =
  "documents.index";

export const ROOM_MANAGER_CUSTOM_PERMISSIONS = {
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_SHOW]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_SHOW,
    label: "Voir le détail d’un hébergement",
  },
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_BOOKING]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_BOOKING,
    label: "Voir les réservations d’un hébergement",
  },
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_METRICS]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_METRICS,
    label: "Voir les statistiques d’un hébergement",
  },
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_BOOKLET]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_BOOKLET,
    label: "Voir la fiche hébergement en PDF",
  },
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_DISCOUNTS]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_DISCOUNTS,
    label: "Modifier les promotions d’un hébergement",
  },
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_ANNUAL_PERIOD]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_ANNUAL_PERIOD,
    label: "Modifier les disponibilités (vue annuelle) d’un hébergement",
  },
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_PERIOD]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_PERIOD,
    label: "Modifier les disponibilités d’un hébergement",
  },
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_SEASONS]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_SEASONS,
    label: "Modifier les saisons d’un hébergement",
  },
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_SEASONS_SETTINGS]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_SEASONS_SETTINGS,
    label: "Modifier les tarifs d’un hébergement",
  },
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_PHOTO]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_PHOTO,
    label: "Modifier les photos d’un hébergement",
  },
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_EDIT]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_EDIT,
    label: "Modifier les informations d’un hébergement",
  },
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_BOOK]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_BOOK,
    label: "Créer une réservation",
  },
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_FEATURES]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_FEATURES,
    label: "Modifier les fonctionnalités d’un hébergement",
  },
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_INTEGRATE]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_INTEGRATE,
    label: "Intégrer un hébergement sur un site externe",
  },
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_COMMENTS]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_COMMENTS,
    label: "Voir les avis clients d’un hébergement",
  },
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_INDEX]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_INDEX,
    label: "Lister les réservations",
  },
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_RESUME]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_RESUME,
    label: "Télécharger le résumé d’une réservation",
  },
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_CONFIRM_OACK]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_CONFIRM_OACK,
    label: "Confirmer la location sur demande d’une réservation",
  },
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_CONFIRM_VDM]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_CONFIRM_VDM,
    label: "Confirmer une réservation de dernière minute",
  },
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_VOUCHER]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_VOUCHER,
    label: "Télécharger le bon d’échange d’une réservation",
  },
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_CERTIFICATE]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_CERTIFICATE,
    label: "Télécharger l’attestation de séjour d’une réservation",
  },
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_CONTRACT]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_CONTRACT,
    label: "Télécharger le contrat de location d’une réservation",
  },
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_TRAVELERS]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_TRAVELERS,
    label:
      "Modifier les voyageurs d’une réservation pour l’attestation de séjour",
  },
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_SHOW]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_SHOW,
    label: "Voir le détail d’une réservation",
  },
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_PAYMENT_HISTORY]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_PAYMENT_HISTORY,
    label:
      "Voir l’historique des paiements d’une réservation en location directe",
  },
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_PAY]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_PAY,
    label: "Ajouter des paiements sur un réservation en location directe",
  },
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_EDIT]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_EDIT,
    label: "Modifier une réservation en location directe",
  },
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_PROMISE]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_PROMISE,
    label: "Valider une réservation en location directe en devis",
  },
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_ABORT]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_ABORT,
    label: "Refuser une réservation en location directe en devis",
  },
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_RESTORE]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_RESTORE,
    label: "Restaurer une réservation en location directe",
  },
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_CANCEL]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_CANCEL,
    label: "Annuler une réservation en location directe",
  },
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_WELCOME_TRAVELERS]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_WELCOME_TRAVELERS,
    label: "Gère l’accueil des voyageurs",
  },
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_NEWSLETTER_INDEX]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_NEWSLETTER_INDEX,
    label: "Recevoir les newsletters",
  },
  [ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_DOCUMENTS_INDEX]: {
    id: ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_DOCUMENTS_INDEX,
    label: "Recevoir les documents propriétaire",
  },
};

export const ROOM_MANAGER_CUSTOM_PERMISSION_LIST = Object.values(
  ROOM_MANAGER_CUSTOM_PERMISSIONS,
);

export const ROOM_MANAGER_CUSTOM_PERMISSION_GROUP_MAP = {
  rooms: [
    ROOM_MANAGER_CUSTOM_PERMISSIONS[
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_SHOW
    ],
    ROOM_MANAGER_CUSTOM_PERMISSIONS[
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_METRICS
    ],
    ROOM_MANAGER_CUSTOM_PERMISSIONS[
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_BOOKLET
    ],
    ROOM_MANAGER_CUSTOM_PERMISSIONS[
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_DISCOUNTS
    ],
    ROOM_MANAGER_CUSTOM_PERMISSIONS[
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_ANNUAL_PERIOD
    ],
    ROOM_MANAGER_CUSTOM_PERMISSIONS[
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_PERIOD
    ],
    ROOM_MANAGER_CUSTOM_PERMISSIONS[
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_PHOTO
    ],
    ROOM_MANAGER_CUSTOM_PERMISSIONS[
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_EDIT
    ],
    ROOM_MANAGER_CUSTOM_PERMISSIONS[
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_FEATURES
    ],
    ROOM_MANAGER_CUSTOM_PERMISSIONS[
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_INTEGRATE
    ],
    ROOM_MANAGER_CUSTOM_PERMISSIONS[
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_SEASONS
    ],
    ROOM_MANAGER_CUSTOM_PERMISSIONS[
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_SEASONS_SETTINGS
    ],
  ],
  bookings: [
    ROOM_MANAGER_CUSTOM_PERMISSIONS[
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_INDEX
    ],
    ROOM_MANAGER_CUSTOM_PERMISSIONS[
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_BOOK
    ],
    ROOM_MANAGER_CUSTOM_PERMISSIONS[
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_RESUME
    ],
    ROOM_MANAGER_CUSTOM_PERMISSIONS[
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_CONFIRM_OACK
    ],
    ROOM_MANAGER_CUSTOM_PERMISSIONS[
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_CONFIRM_VDM
    ],
    ROOM_MANAGER_CUSTOM_PERMISSIONS[
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_VOUCHER
    ],
    ROOM_MANAGER_CUSTOM_PERMISSIONS[
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_CERTIFICATE
    ],
    ROOM_MANAGER_CUSTOM_PERMISSIONS[
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_CONTRACT
    ],
    ROOM_MANAGER_CUSTOM_PERMISSIONS[
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_TRAVELERS
    ],
    ROOM_MANAGER_CUSTOM_PERMISSIONS[
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_SHOW
    ],
    ROOM_MANAGER_CUSTOM_PERMISSIONS[
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_EDIT
    ],
    ROOM_MANAGER_CUSTOM_PERMISSIONS[
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_PROMISE
    ],
    ROOM_MANAGER_CUSTOM_PERMISSIONS[
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_ABORT
    ],
    ROOM_MANAGER_CUSTOM_PERMISSIONS[
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_RESTORE
    ],
    ROOM_MANAGER_CUSTOM_PERMISSIONS[
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_CANCEL
    ],
    ROOM_MANAGER_CUSTOM_PERMISSIONS[
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_WELCOME_TRAVELERS
    ],
  ],
  comments: [
    ROOM_MANAGER_CUSTOM_PERMISSIONS[
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_COMMENTS
    ],
  ],
  payments: [
    ROOM_MANAGER_CUSTOM_PERMISSIONS[
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_PAYMENT_HISTORY
    ],
    ROOM_MANAGER_CUSTOM_PERMISSIONS[
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_PAY
    ],
  ],
  newsletters: [
    ROOM_MANAGER_CUSTOM_PERMISSIONS[
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_NEWSLETTER_INDEX
    ],
  ],
  documents: [
    ROOM_MANAGER_CUSTOM_PERMISSIONS[
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_DOCUMENTS_INDEX
    ],
  ],
};

// Permissions groupées leur action

export const ROOM_VIRTUAL_MANAGER_PERMISSIONS_GROUPS = [
  {
    id: "rooms",
    label: "Permissions hébergements",
    permissions: ROOM_MANAGER_CUSTOM_PERMISSION_GROUP_MAP.rooms,
  },
  {
    id: "bookings",
    label: "Permissions réservations",
    permissions: ROOM_MANAGER_CUSTOM_PERMISSION_GROUP_MAP.bookings,
  },
  {
    id: "comments",
    label: "Permissions avis client",
    permissions: ROOM_MANAGER_CUSTOM_PERMISSION_GROUP_MAP.comments,
  },
  {
    id: "payments",
    label: "Permissions paiements",
    permissions: ROOM_MANAGER_CUSTOM_PERMISSION_GROUP_MAP.payments,
  },
  {
    id: "newsletters",
    label: "Permissions newsletters",
    permissions: ROOM_MANAGER_CUSTOM_PERMISSION_GROUP_MAP.newsletters,
  },
  {
    id: "documents",
    label: "Permissions documents propriétaire",
    permissions: ROOM_MANAGER_CUSTOM_PERMISSION_GROUP_MAP.documents,
  },
];

// Groupe par défaut pour les mandataires

/** Accueil */
export const ROOM_MANAGER_ACCESS_LEVEL_VALUE_RECEPTION = "reception";
/** Accueil et VDM */
export const ROOM_MANAGER_ACCESS_LEVEL_VALUE_RECEPTION_VDM = "reception_vdm";
/** Accueil, VDM et location sur demande */
export const ROOM_MANAGER_ACCESS_LEVEL_VALUE_RECEPTION_VDM_OACK =
  "reception_vdm_oack";
/** Tous les droits */
export const ROOM_MANAGER_ACCESS_LEVEL_VALUE_ALL = "all";

export const ROOM_MANAGER_ACCESS_LEVELS = {
  [ROOM_MANAGER_ACCESS_LEVEL_VALUE_RECEPTION]: {
    id: ROOM_MANAGER_ACCESS_LEVEL_VALUE_RECEPTION,
    label: "accueil",
    description: "groupe permettant l’accueil des voyageurs dans l’hébergement",
    permissions: [
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_SHOW,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_BOOKING,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_SHOW,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_VOUCHER,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_RESUME,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_WELCOME_TRAVELERS,
    ],
  },
  [ROOM_MANAGER_ACCESS_LEVEL_VALUE_RECEPTION_VDM]: {
    id: ROOM_MANAGER_ACCESS_LEVEL_VALUE_RECEPTION_VDM,
    label: "accueil et VDM",
    description:
      "groupe permettant l’accueil des voyageurs dans l’hébergement et l’acceptation des réservations en vente de dernière minute",
    permissions: [
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_SHOW,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_BOOKING,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_SHOW,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_VOUCHER,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_RESUME,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_CONFIRM_VDM,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_WELCOME_TRAVELERS,
    ],
  },
  [ROOM_MANAGER_ACCESS_LEVEL_VALUE_RECEPTION_VDM_OACK]: {
    id: ROOM_MANAGER_ACCESS_LEVEL_VALUE_RECEPTION_VDM_OACK,
    label: "accueil, VDM et location sur demande",
    description:
      "groupe permettant l’accueil des voyageurs dans l’hébergement, l’acceptation des réservations en vente de dernière minute et en location sur demande",
    permissions: [
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_SHOW,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_BOOKING,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_SHOW,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_VOUCHER,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_RESUME,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_CONFIRM_OACK,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_CONFIRM_VDM,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_WELCOME_TRAVELERS,
    ],
  },
  [ROOM_MANAGER_ACCESS_LEVEL_VALUE_ALL]: {
    id: ROOM_MANAGER_ACCESS_LEVEL_VALUE_ALL,
    label: "tous les droits",
    description:
      "groupe permettant l’accès à toutes les fonctionnalités de l’hébergement",
    permissions: [
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_SHOW,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_EDIT,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_PHOTO,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_PERIOD,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_SEASONS,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_SEASONS_SETTINGS,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_ANNUAL_PERIOD,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_BOOK,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_FEATURES,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_DISCOUNTS,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_METRICS,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_BOOKLET,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_COMMENTS,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_BOOKING,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_ROOMS_INTEGRATE,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_INDEX,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_SHOW,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_PAYMENT_HISTORY,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_RESUME,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_VOUCHER,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_CONTRACT,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_CONFIRM_OACK,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_CONFIRM_VDM,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_CERTIFICATE,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_TRAVELERS,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_PAY,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_EDIT,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_PROMISE,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_ABORT,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_RESTORE,
      ROOM_MANAGER_CUSTOM_PERMISSION_VALUE_BOOKINGS_CANCEL,
    ],
  },
};

export const ROOM_MANAGER_ACCESS_LEVEL_LIST = Object.values(
  ROOM_MANAGER_ACCESS_LEVELS,
);
